import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';
import CustomerApprovalRejectDocumentsModal from './CustomerApprovalRejectDocumentsModal';
import CustomerApprovalApproveDocumentsModal from './CustomerApprovalApproveDocumentsModal';
import customerApprovalLookupServices from '../../services/customerApprovalLookupServices';
import { NotificationManager } from 'react-notifications';
import { customerApprovalStatus } from '@ami/react/shared';
import { formatDateWithTime } from '@ami/react/core';
import CustomerApprovalDocumentItem from './CustomerApprovalDocumentItem';

class CustomerApprovalItem extends React.Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    item: PropTypes.object.isRequired,
    fullName: PropTypes.string.isRequired,
    onUpdated: PropTypes.func.isRequired,
  };

  state = {
    showRejectModal: false,
    showCancelConfirmationModal: false,
    entity: null,
  };

  async componentDidMount() {
    await this.loadEntity();
  }

  loadEntity = async () => {
    this.setState({
      entity: await customerApprovalLookupServices.getView(this.props.item.id),
    });
  };

  hideRejectModal = () => this.setState({ showRejectModal: false });

  handleOnEdit() {
    this.props.onUpdated();
  }

  handledConfirm = async () => {
    customerApprovalLookupServices
      .approve(this.props.item.id, this.props.fullName)
      .then(async () => {
        this.props.onUpdated();
        NotificationManager.success('Customer Approval approved');
      })
      .finally(() => this.setState({ showCancelConfirmationModal: false }));
  };

  render() {
    const { item } = this.props;
    const { showRejectModal, showCancelConfirmationModal, entity } = this.state;
    const showActions =
      item.status === customerApprovalStatus.waitingForApproval.id;
    const showApproved = item.status === customerApprovalStatus.approved.id;
    const showRejected = item.status === customerApprovalStatus.rejected.id;
    return (
      <div className="row">
        <div className="col-sm-2"></div>
        <div className="card-deck col-sm-8">
          <div className="card mb-4 box-shadow">
            <div className="card-body">
              <div className="recent-list-wrapper pb-0">
                <div className="row justify-content-right">
                  <div className="col">
                    <h5 className="text-break-line">
                      {item.approvalInstructions}
                    </h5>
                  </div>
                  <div className="col">
                    <div className="text-end">
                      <strong>{item.orderLineName}</strong>
                    </div>
                    <div className="text-end">
                      <strong>{item.orderPartNumber}</strong>
                    </div>
                  </div>
                </div>
                {entity &&
                  entity.documents.length !== 0 &&
                  entity.documents
                    .filter((x) => !x.isDeleted)
                    .map((document, i) => (
                      <CustomerApprovalDocumentItem
                        key={i}
                        entity={entity}
                        document={document}
                      />
                    ))}
                {showActions && (
                  <div className="d-flex justify-content-center">
                    <Button
                      type="button"
                      color="primary"
                      onClick={() => {
                        this.setState({ showCancelConfirmationModal: true });
                      }}
                      className="m-1 ms-3"
                    >
                      Approve
                    </Button>
                    <div className="mt-2 ms-3">or</div>
                    <Button
                      type="button"
                      color="danger"
                      onClick={() => {
                        this.setState({ showRejectModal: true });
                      }}
                      className="m-1 ms-3"
                    >
                      Reject
                    </Button>
                  </div>
                )}
                {showApproved && (
                  <div className="d-flex justify-content-center text-lg">
                    <i
                      id="approved"
                      className="fa fa-check-circle fa-lg text-success me-2"
                    />{' '}
                    Approved {formatDateWithTime(item.dateCustomerApproved)} by{' '}
                    {item.customerFullName}
                  </div>
                )}
                {showRejected && (
                  <div>
                    <div className="d-flex justify-content-center text-lg">
                      <i
                        id="rejected"
                        className="fa fa-times-circle fa-lg text-danger me-2 mt-1"
                      />{' '}
                      Rejected {formatDateWithTime(item.dateCustomerRejected)}{' '}
                      by {item.customerFullName}
                    </div>
                    <div className="d-flex justify-content-center text-break-line">
                      <i>Reason: {item.rejectReason}</i>
                    </div>
                  </div>
                )}
                <CustomerApprovalApproveDocumentsModal
                  show={showCancelConfirmationModal}
                  onShowUpdated={(showCancelConfirmationModal) =>
                    this.setState({ showCancelConfirmationModal })
                  }
                  onConfirm={this.handledConfirm}
                />
                <CustomerApprovalRejectDocumentsModal
                  id={item.id}
                  fullName={this.props.fullName}
                  onHide={this.hideRejectModal}
                  onChanged={() => this.handleOnEdit()}
                  show={showRejectModal}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-2"></div>
      </div>
    );
  }
}

export default withRouter(CustomerApprovalItem);
